import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { ConfirmDialog } from "../../dialog/confirm";
import { labels } from "./labels";

export const showPhotoRemoveConfirmDialogAsync = (
	nbrOfPhotosToDelete: number,
	nbrOfUsedPhotosToDelete: number,
) =>
	showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<ConfirmDialog
			titleLabel={labels.title}
			messageHtmlLabel={labels.message}
			messageHtmlReplacements={[
				nbrOfPhotosToDelete.toString(),
				nbrOfUsedPhotosToDelete.toString(),
			]}
			isOpen={isOpen}
			cancelLabel={labels.cancel}
			okLabel={labels.ok}
			onOk={() => resolve(true)}
			onCancel={() => resolve(false)}
		/>
	));
